import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import TableText from "../../../component/atoms/text/table/tableText";
import FileImgPreview from "../../../component/molecules/fileImgPreview";
import GoBack from "../../../component/molecules/goBack";
import Pagination from "../../../component/molecules/pagination";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import StudentModal from "../_component/studentModal";
import LectureApi from "../../../api/lecture.api";
import { useRecoilState } from "recoil";
import { currentLectureType } from "../../../store/currentCategory";
import { homeUrl } from "../../../constants/url";

const LectureDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [lectureInfo, setLectureInfo] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentType, setCurrentType] = useRecoilState(currentLectureType);

  const tabList = [
    {
      title: "강의 상세",
      link: `${route.lecture_lecture_info}/${id}`,
      originLink: route.lecture_lecture_info,
    },
    {
      title: "커리큘럼",
      link: `${route.lecture_lecture_curriculum}/${id}`,
      originLink: route.lecture_lecture_curriculum,
    },
    {
      title: "수강후기 관리",
      link: `${route.lecture_lecture_review}/${id}`,
      originLink: route.lecture_lecture_review,
    },
  ];

  useEffect(() => {
    getLectureList();
  }, []);

  const getLectureList = async () => {
    try {
      const response = (await LectureApi.getLectureById(id)).data.data.content;

      setCurrentType(response.lectureCategoryType);

      setLectureInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await LectureApi.delLecture(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 수강생 내역
  useEffect(() => {
    getStudentList();
  }, [window.location]);

  const [studentList, setStudentList] = useState([]);

  const getStudentList = async () => {
    try {
      const data = {
        page: searchParams.get("page"),
        size: pagination.size,
        lectureVideoId: id,
      };
      let responseData = (await LectureApi.getStudentList(data)).data.data;

      setStudentList(
        responseData.content.map((item) => {
          return {
            ...item,
            lectureType: item.lectureVideoFlag
              ? getLectureType(item.lecture?.lectureCategoryType)
              : "컨설팅",
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  const getLectureType = (type) => {
    return type === "FINANCE_STUDY" ? "금융 스터디" : "유료 강의";
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack
              onClick={() => {
                if (currentType === "FINANCE_STUDY") {
                  navigate(route.lecture_lecture_finance);
                } else {
                  navigate(route.lecture_lecture_paid);
                }
              }}
            />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.lecture_lecture_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          <DetailPage>
            <DetailPageTitle>기본 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.activation ? "활성" : "비활성"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>유형</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.lectureCategoryType === "FINANCE_STUDY"
                    ? "금융 스터디"
                    : "유료 강의"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.lectureCategory?.title}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>태그</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.tag?.reverse()?.join(", ")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>수강 인원</DetailFormTitle>
                <DetailFormText>{lectureInfo.studentCount}명</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강의 금액</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.price?.toLocaleString()}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>총 매출액</DetailFormTitle>
                <DetailFormText>
                  {lectureInfo.totalSalePrice?.toLocaleString()}원
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>강의 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>강의명</DetailFormTitle>
                <DetailFormText>{lectureInfo.title}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>수강기간</DetailFormTitle>
                {!lectureInfo.limitFlag ? (
                  <DetailFormText>{lectureInfo.period}일</DetailFormText>
                ) : (
                  <DetailFormText>무제한</DetailFormText>
                )}
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  썸네일 이미지
                  <br />
                  (권장사이즈 585*373)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={lectureInfo.thumbnailOriginFileName}
                  serverFileName={lectureInfo.thumbnailServerFileName}
                  imgStyle={{ width: "150px", height: "94px" }}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강의 소개</DetailFormTitle>
                <DetailFormText
                  onClick={() => {
                    window.open(
                      homeUrl + `/finlive/lecture/detail/${id}`,
                      "_blank"
                    );
                  }}
                  style={{ textDecorationLine: "underline", cursor: "pointer" }}
                >
                  미리보기
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>강사 소개</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>
                  강사 사진
                  <br />
                  (권장사이즈 380*380)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={lectureInfo.instructorOriginFileName}
                  serverFileName={lectureInfo.instructorServerFileName}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강사명</DetailFormTitle>
                <DetailFormText>{lectureInfo.instructorName}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>소개글</DetailFormTitle>
                <DetailFormText>{lectureInfo.instructorIntro}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>경력사항</DetailFormTitle>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {lectureInfo.career?.map((item, index) => {
                    return <DetailFormText key={index}>{item}</DetailFormText>;
                  })}
                </div>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>수강생 내역</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <Table
                style={{
                  width: 964,
                }}
              >
                <colgroup>
                  {/* 날짜/시간 */}
                  <col width="228px" />
                  {/* 아이디 */}
                  <col width="93px" />
                  {/* 이름 */}
                  <col width="378px" />
                  {/* 결제 금액 */}
                  <col width="109px" />
                  {/* 수강률 */}
                  <col width="80px" />
                  {/* 상세보기 */}
                  <col width="77px" />
                </colgroup>
                <thead>
                  <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                    <Th
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <TableText>날짜/시간</TableText>
                    </Th>
                    <Th>
                      <TableText>아이디</TableText>
                    </Th>
                    <Th>
                      <TableText>이름</TableText>
                    </Th>
                    <Th>
                      <TableText>결제 금액</TableText>
                    </Th>
                    <Th>
                      <TableText>수강률</TableText>
                    </Th>
                    <Th>
                      <TableText>상세보기</TableText>
                    </Th>
                  </Tr>
                </thead>
                <tbody>
                  {studentList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        style={{ height: "59px", background: "#fff" }}
                      >
                        <Td
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <TableText>
                            {moment(item.createdAt).format(
                              "YYYY/MM/DD HH:mm:ss"
                            )}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "80px",
                            }}
                          >
                            {item.member?.account}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText>{item.member?.name}</TableText>
                        </Td>
                        <Td>
                          <TableText>
                            {item.payment?.realPay.toLocaleString()}원
                          </TableText>
                        </Td>
                        <Td>
                          <TableText>{item.progressPercent}%</TableText>
                        </Td>
                        <Td>
                          <DetailBtn
                            onClick={() => {
                              setSelectedData(item);
                              setDetailModalOpen(true);
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination
                route={route.lecture_lecture_info + `/${id}`}
                queryString={""}
                currentPage={page}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <StudentModal data={selectedData} setModalOpen={setDetailModalOpen} />
      ) : (
        ""
      )}
    </>
  );
};

export default LectureDetail;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
